import { Button } from 'antd';
import React, { Children } from 'react';
import './CampignIntroComponent.styles.scss';

const CampignIntroComponent = ({ children, title, subtext, image, colSize }) => {
  return (
    <div className="common_card intro_campaign py-4 px-2 h-100">
      <div className="d-flex align-items-center">
        <div className={`col-md-${colSize}`}>
          <h4>{title}</h4>
          <p>{subtext}</p>
          {children}
        </div>
        <div className={`col-md-${12 - colSize}`}>
          <img src={image}
            className="img-fluid"
            alt="Campaign" />
        </div>
      </div>
    </div>
  );
};

export default CampignIntroComponent;
